module.exports = __webpack_public_path__ + "img/framenew_box09.04637f43.jpg";